import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Utente } from 'src/app/models/rbac/Utente';
import { FrattaleService } from './frattale.service';

@Injectable({
  providedIn: 'root'
})
export class UtenteService extends FrattaleService {
  private utente: Utente = new Utente()
  /* url: string = 'http://localhost/www/tradingfrattale/php/'
  //BOH??
  remoteUrl: string = 'https://tradingfrattale.it/php/' */
  head: HttpHeaders = new HttpHeaders
  private _isLogInUser: BehaviorSubject<Utente> = new BehaviorSubject<Utente>(new Utente())
  public isLogin: Observable<Utente> = this._isLogInUser.asObservable()
  private isLoggedIn: boolean = false

  constructor(@Inject(HttpClient) protected http: HttpClient) {
    super(http)
    this.head.set('tasm', 'prova')
  }

  logout() {
    this.utente = new Utente()
    this.setIsLogin(new Utente())
  }

  setIsLogin(u: Utente) {
    this.isLoggedIn = u.getTipoUt() != 'guest'
    this._isLogInUser.next(u)
  }

  isLogged() {
    return this.isLoggedIn
  }

  setUtente(dati: any) {
    window.sessionStorage.setItem('utente', JSON.stringify(dati))
    this.utente.setUtente(dati)
  }

  loginUtente(dati: any) {
    let data = {
      action: 'gestione_utenti',
      cmd: 'loginUtente',
      email: dati.email,
      password: dati.password
    }
    return this.http.post(this.url, data, { headers: this.head })
  }


  registraUtente(e: string) {
    let data = {
      action: 'gestione_utenti',
      cmd: 'add',
      email: e
    }
    this.http.post(this.url, data, { headers: this.head }).subscribe(
      (ut: any) => {
        if (ut['error']) {
          alert('errore')
        } else {
          this.utente!.setUtente(ut['res'].email)
          this.setIsLogin(this.utente)
        }
      }
    )
  }

  sendCode(email: string) {
    let data = {
      cmd: 'sendCode',
      action: 'gestione_utenti',
      email: email
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  registraDatiUtente(dati: any) {
    let data = {
      cmd: 'gestione_utenti',
      action: 'gestione_utenti',
      email: this.utente!.getEmail(),
      nome: dati.nome,
      cognome: dati.cognome,
      cf: dati.cf,
      news: dati.news,
      indirizzo: dati.indirizzo

    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  cambiaPassword(e: string, p: string) {
    let dati = {
      action: 'gestione_utenti',
      cmd: 'cambiaPassword',
      password: p,
      email: e
    }
    return this.http.post(this.url, dati, { headers: this.head })
  }

  getUtente(): Utente {
    return this.utente
  }

  getListaUtenti() {
    let data = {
      action: 'gestione_utenti',
      cmd: 'getListaUtenti'
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  getRuoli() {
    let data = {
      action: 'gestione_utenti',
      cmd: 'getRuoli'
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  modificaUtente(dati: any) {
    let data = {
      action: 'gestione_utenti',
      cmd: 'modificaUtente',
      id: dati.id,
      email: dati.email,
      nome: dati.nome,
      cognome: dati.cognome,
      ruolo: dati.ruolo,
      abilitato: dati.abilitato
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  creaUtente(dati: any) {
    let data = {
      action: 'gestione_utenti',
      cmd: 'creaUtente',
      email: dati.email,
      nome: dati.nome,
      cognome: dati.cognome,
      ruolo: dati.ruolo,
      abilitato: dati.abilitato
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  modificaPassword(dati: any) {
    let data = {
      action: 'gestione_utenti',
      cmd: 'modificaPassword',
      id: dati.id,
      password: dati.password
    }
    return this.http.post(this.url, data, { headers: this.head })
  }

  aggiungiAccount(dati: any) {
    let data = {
      action: 'accounts',
      cmd: 'addaccount',
      utente_id: dati.utente_id,
      nome: dati.nome,
      broker: dati.broker,
      numero: dati.numero,
      valuta: dati.valuta
    }
    return this.http.post(this.url, data, { headers: this.head })
  }
}
